import { Entity, RELATION_PART_OF } from '@backstage/catalog-model';
import { TableColumn } from '@backstage/core-components';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { SystemCell } from './SystemCell';

/**
 * A System column that falls back through ServiceGroup - see SystemCell.
 * Generic over any entity kind's table row type (Entity subtypes), so it
 * works for the Catalog index page (CatalogTableRow, which has an `entity`
 * field alongside a separate `resolved` one - see catalogColumns) as much as
 * for a plain Entity[] table like Provided APIs or Depends on Components.
 */
export function createServiceGroupAwareSystemColumn<
  T extends Entity,
>(): TableColumn<T> {
  return {
    title: 'System',
    render: entity => <SystemCell entity={entity} />,
  };
}

/**
 * A Service Group column, generic over any Entity subtype. Thin wrapper
 * around the stock generic relation-column factory - ServiceGroup isn't a
 * built-in kind so there's no EntityTable.columns.createServiceGroupColumn,
 * but createEntityRelationColumn covers exactly this shape already.
 */
export function createServiceGroupColumn<T extends Entity>(): TableColumn<T> {
  return EntityTable.columns.createEntityRelationColumn<T>({
    title: 'Service Group',
    relation: RELATION_PART_OF,
    defaultKind: 'servicegroup',
    filter: { kind: 'servicegroup' },
  });
}
